module.exports = __webpack_public_path__ + "static/media/about-family-1.032903ed.jpg";